const decimalRegex = /^\d+(\,\d{1,2})?$/;

export const numericCommaStringNormalizer = (
    value: any,
    previousValue?: any
): string | number => {
    if (typeof value === "number") {
        return value;
    } else if (!value || typeof value !== "string") {
        return "";
    } else if (!numericCommaStringValidator(value)) {
        return !previousValue ? "" : previousValue;
    }

    return value;
};

export const numericCommaStringFormatter = (
    value: any,
    name: string
): string | number => {
    if (typeof value === "number") {
        return value;
    } else if (!value || typeof value !== "string") {
        return "";
    }

    const removedAllNonDecimal = value.replace(/[^0-9$.,]/g, "");
    const replacedDotsWithCommas = removedAllNonDecimal.replace(/\./g, ",");

    return replacedDotsWithCommas;
};

export const numericCommaStringValidator = (value: string): boolean => {
    if (typeof value === "number") {
        return true;
    } else if (!value || typeof value !== "string") {
        return false;
    }

    return decimalRegex.test(value.replace(/\./g, ","));
};

export const numericCommaStringToDecimal = (value: any): number => {
    if (typeof value === "number") {
        return value;
    } else if (!value || typeof value !== "string") {
        return NaN;
    }

    return Number(value.replace(/\,/g, "."));
};



// WEBPACK FOOTER //
// ./src/util/numericTransformation.ts